<template>
    <b-card id="edicaoItensVencedoresLoteLicitacao" class="mx-5" bg-variant="light" no-body>
        <template #header>
            <h6 class="mb-0 titulo-mobile d-flex justify-content-between align-items-center">
                Itens do Lote
                <busca-tabela @busca="buscarTexto" />
            </h6>
        </template>
        <b-table :fields="fieldsItens" :items="itensLote" :busy="tableBusyItens" :current-page="currentPageItens" hover
            no-border-collapse striped small sort-by="" stacked="sm" responsive show-empty>
            <template #empty>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
                <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                </div>
            </template>
            <template #cell(DeItemMatServ)="data">
                <TextoLongo :texto="data.item.DeItemMatServ" :limite="30" class="w-100" />
            </template>
            <template #cell(VlUnitarioLicitado)="data">
                <money class="form-control" v-if="data.item.modoEdicao" :disabled="data.item.loading"
                    v-model="data.item.novoValorUnit" v-bind="vMoney4CasasOptions"></money>
                <span v-else>{{ data.value }}</span>
            </template>
            <template #cell(NmMarcaItemMatServ)="data">
                <b-form-input v-if="data.item.modoEdicao" :disabled="data.item.loading" v-model="data.item.novaMarca"
                    maxlength="100" />
                <span v-else>{{ data.value }}</span>
            </template>

            <template v-slot:cell(actions)="row">
                <b-overlay v-if="row.item.modoEdicao" :show="row.item.loading" variant="transparent" opacity="0.8"
                    blur="1px">
                    <div class="actions-icons">
                        <b-link class="text-dark" @click="salvarEdicaoItemLote(row.item)">
                            <font-awesome-icon icon="save" />
                            <div style="font-size: 12px">Salvar</div>
                        </b-link>
                        <b-link class="text-dark" @click="pararEdicaoItemLote(row.item)">
                            <font-awesome-icon icon="cancel" />
                            <div style="font-size: 12px">Cancelar {{ row.item.IdItemLoteLicitacao ? 'edição' : '' }}
                            </div>
                        </b-link>
                    </div>
                </b-overlay>
                <div v-else class="actions-icons">
                    <b-link v-if="lote && lote.IdParticipanteLicitacao" class="text-dark"
                        @click="editarItemLoteLicitacao(row.item)">
                        <font-awesome-icon icon="edit" />
                        <div style="font-size: 12px">Editar item</div>
                    </b-link>
                </div>
            </template>
        </b-table>
        <table-pagination v-if="totalRowsItens > pageSize" :total-rows="totalRowsItens" :per-page="pageSize"
            class="ml-3 mb-1" :firstCurrentPg="currentPageItens" @pageChange="pageChange" />
    </b-card>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue"
import BuscaTabela from '@/components/shared/BuscaTabela.vue'
import ldiService from '@/services/licitacoes/ldiService'
import { fieldEdicaoItemLicitacao, fieldsItemLoteVencedorLicitacao } from '@/types/licitacoes/ldi/fields-item-licitacao'
import { ItemLicitacao } from '@/types/licitacoes/ldi/item-licitacao'
import { LoteLicitacao } from '@/types/licitacoes/ldi/lote-licitacao'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { Money } from 'v-money'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'
import TextoLongo from '@/components/shared/TextoLongo.vue'

const CompProps = Vue.extend({
    name: 'EditarItensVencedoresLoteLicitacao',
    components: { BuscaTabela, Money, TablePagination, TextoLongo },
    props: {
        idLote: {
            type: Number,
            required: true
        }
    }
})

@Component
export default class EditarItensVencedoresLoteLicitacao extends mixins(UtilsTS, CompProps) {
    fieldsItens: TableField[] = [...fieldsItemLoteVencedorLicitacao, fieldEdicaoItemLicitacao]
    itensLote: ItemLicitacao[] = []
    pageSize = 5
    currentPageItens = 1
    totalRowsItens = 0
    tableBusyItens = false
    filtroTexto = ''
    lote: LoteLicitacao | null = null

    get existeEdicaoItem() {
        return this.itensLote.some(lo => lo.modoEdicao)
    }

    async mounted() {
        this.loadData()
    }

    async loadData() {
        try {
            this.tableBusyItens = true
            this.lote = await ldiService.buscarLotePorId(this.idLote)
            const response = await ldiService.buscarItensLote(this.idLote, this.currentPageItens, this.pageSize, this.filtroTexto)
            if (response) {
                this.itensLote = response.itensLote.map(l => {
                    const item = Object.assign(new ItemLicitacao(), l)
                    return item
                })
                this.totalRowsItens = response.totalRows
                //console.log('load data itensLote: ', this.itensLote)
            } else {
                this.$toast.error('Erro ao consultar os itens do lote desta licitação.');
            }
            //console.log("itensLote", this.itensLote)
        } finally {
            this.tableBusyItens = false;
        }
    }
    async pageChange(value) {
        this.currentPageItens = value;
        await this.loadData();
    }
    async editarItemLoteLicitacao(value: ItemLicitacao) {
        const meuItemLote = this.itensLote.find(lo => lo.IdItemLoteLicitacao === value.IdItemLoteLicitacao)
        if (meuItemLote) {
            meuItemLote.modoEdicao = true
            meuItemLote.novaMarca = meuItemLote.novaMarca || meuItemLote.NmMarcaItemMatServ
            meuItemLote.novoValorUnit = meuItemLote.novoValorUnit || meuItemLote.VlUnitarioLicitado
        }
    }
    pararEdicaoItemLote(itemLote: ItemLicitacao) {
        //console.log("id do item lote: ", itemLote.IdItemLoteLicitacao)

        if (itemLote.IdItemLoteLicitacao) {
            const meuItemLote = this.itensLote.find(lo => lo.IdItemLoteLicitacao === itemLote.IdItemLoteLicitacao)
            if (meuItemLote) {
                meuItemLote.modoEdicao = false
            }
        } else {
            //console.log(itemLote, itemLote.IdItemLoteLicitacao)
            this.itensLote = this.itensLote.filter(l => l.IdItemLoteLicitacao !== undefined)
            this.$emit('input', this.itensLote);
        }
    }
    async salvarEdicaoItemLote(itemLote: ItemLicitacao) {
        const meuItemLote = this.itensLote.find(lo => lo.IdItemLoteLicitacao === itemLote.IdItemLoteLicitacao)
        try {
            if (meuItemLote) {
                meuItemLote.loading = true
                itemLote.NmMarcaItemMatServ = itemLote.novaMarca
                itemLote.VlUnitarioLicitado = itemLote.novoValorUnit

                const retorno = await ldiService.alterarItemLoteVencido(itemLote)
                retorno.IdLoteLicitacao = this.idLote
                this.itensLote = this.itensLote.filter(l => l.IdItemLoteLicitacao !== itemLote.IdItemLoteLicitacao)
                this.itensLote.unshift(retorno.itemLote)
                this.$toast.success(`O item ${retorno.itemLote.NmMarcaItemMatServ} foi atualizado.`)
                this.$emit('loteAtualizado', retorno);
            }
        } catch (e: any) {
            this.tratarError(e)
        }
        finally {
            if (meuItemLote)
                meuItemLote.loading = false
        }
    }

    /**
     * Atualiza a lista de itens de acordo com o texto passado
     * @param texto String pedida pelo usuário
     */
    async buscarTexto(texto: string) {
        this.filtroTexto = texto
        this.currentPageItens = 1
        this.loadData()
    }
}


</script>